import { GetTermsGlobalAccountApiProps } from 'services/terms-global-account/types'

import { interWbHttp } from '@interco/inter-webview-bridge'

export const getTermsGlobalAccount = async (): Promise<GetTermsGlobalAccountApiProps[]> => {
  const endpoint = '/app-pf/ia/global-account/v2/creation/account/terms'
  const { response } = await interWbHttp.get({
    endpoint,
    headers: {},
    options: {},
  })
  return JSON.parse(response)
}
